<template>
	<div
		v-if="!isFiltering"
		class="flex w-full flex-col flex-wrap items-center bg-gray-130 px-4 py-12"
	>
		<h2 class="mb-4 mt-0 text-center">
			Sorry, we don’t have any matching results.
		</h2>
		<p class="m-0 text-center">
			Try editing your search filter(s) or viewing all our cars.
		</p>
		<div class="mt-6 flex justify-center">
			<CarbarButton
				is-silent-filter
				background-color="bg-orange-400"
				@click="clearAllFilters"
			>
				Clear all filters
			</CarbarButton>
		</div>
	</div>
</template>

<script setup>
import { computed } from 'vue'
import CarbarButton from '@/components/buttons/CarbarButton.vue'
import { useProductCatalog } from '@/stores/product-catalog'

const productCatalog = useProductCatalog()

const isFiltering = computed(() => productCatalog.isFiltering)

const clearAllFilters = () => {
	productCatalog.clearFilter()
}
</script>
